import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	// This map is populated exclusively from GET /api/v1/feature_flags/.
	flags: {},
	status: 'idle',
	evaluatedAt: null,
	lastSuccessAt: null,
	error: null
};

const gitlabFeatureFlagsSlice = createSlice({
	name: 'gitlabFeatureFlags',
	initialState,
	reducers: {
		gitlabFeatureFlagsFetchStarted: state => {
			// Only the first request needs a loading state. Background refreshes and
			// retries must not unmount feature-gated UI.
			if (state.status === 'idle') state.status = 'loading';
			state.error = null;
		},
		gitlabFeatureFlagsFetched: (state, action) => {
			const { flags, evaluatedAt, fetchedAt } = action.payload;
			state.flags = flags;
			state.status = 'ready';
			state.evaluatedAt = evaluatedAt || null;
			state.lastSuccessAt = fetchedAt || null;
			state.error = null;
		},
		gitlabFeatureFlagsFetchFailed: (state, action) => {
			// Keep the last successful values during a transient polling failure.
			state.status = 'error';
			state.error = action.payload || { message: 'Feature flags unavailable' };
		},
		resetGitlabFeatureFlags: () => initialState
	}
});

export const {
	gitlabFeatureFlagsFetchStarted,
	gitlabFeatureFlagsFetched,
	gitlabFeatureFlagsFetchFailed,
	resetGitlabFeatureFlags
} = gitlabFeatureFlagsSlice.actions;

export const selectGitlabFeatureFlags = state => state && state.gitlabFeatureFlags || initialState;

export const selectGitlabFeatureFlag = (state, flagKey) => {
	const value = selectGitlabFeatureFlags(state).flags[flagKey];
	return typeof value === 'boolean' ? value : false;
};

export const selectGitlabFeatureFlagsReady = state => {
	const status = selectGitlabFeatureFlags(state).status;
	return status === 'ready' || status === 'error';
};

export default gitlabFeatureFlagsSlice.reducer;
